import Constants from './Constants'

export function getBlueprintResource( projectId, blueprintId, path, opts ) {
  return ( dispatch, getState, api ) => {
    return api
      .project( projectId )
      .blueprint( blueprintId )
      .resource( path )
      .get( opts )
      .then( ( resources ) => {
        if ( resources?.items ) {
          dispatch( { type : Constants.GET_RESOURCES, payload : resources } )
        } else {
          dispatch( { type : Constants.GET_RESOURCE, payload : resources } )
        }
        return resources
      } )
      .catch( ( ex ) => {
        console.error( ex )
      } )
  }
}

export default {
  getBlueprintResource
}
